const CorporatePresentationEnum = Object.freeze({
  fr: 'À propos de ce site',
  de: 'Über diesen Standort',
  cs: 'O této lokalitě',
  sk: 'O tejto lokalite',
  es: 'Acerca de este sitio',
  'en-US': 'About this location'
})

export default CorporatePresentationEnum
